<template>
  <div class="department-dialog">
    <el-form :model="ruleForm" :hide-required-asterisk="false" label-width="90px" size="mini" label-position="right" ref="ruleForm" @submit.native.prevent :rules="rules">
      <el-form-item label="部门名称：" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入部门名称" maxlength="20" clearable></el-input>
      </el-form-item>
      <el-form-item label="上级部门：" prop="parent_id">
        <el-cascader ref="cascader" :disabled="isEdit" v-if="visible" :props="props" v-model="departments_id" clearable @change="changeValue"></el-cascader>
      </el-form-item>
      <el-form-item label="部门分类：" prop="department_category_id" v-if="isParent">
        <el-select v-model="ruleForm.department_category_id" clearable placeholder="请选择">
          <el-option v-for="item in departmentType" :key="item.department_category_id" :label="item.name" :value="item.department_category_id">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="部门负责人：" prop="depart_header">
        <el-select v-model="ruleForm.depart_header" filterable remote clearable reserve-keyword placeholder="搜索：姓名 / 邮箱 / 手机号 / 职称" :remote-method="remoteMethod" :loading="searchLoading">
          <el-option v-for="item in leaderList" :key="item.uid" :label="item.realname" :value="item.uid">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="负责人：" prop="department_administrators">
        <el-select v-model="ruleForm.department_administrators" multiple filterable remote clearable reserve-keyword placeholder="搜索：姓名 / 邮箱 / 手机号 / 职称 / 工号" :remote-method="remoteMethod" :loading="searchLoading">
          <el-option v-for="item in leaderList" :key="item.uid" :label="item.realname" :value="item.uid">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="footer-btns">
      <div>
        <p v-if="isEdit" @click="delDepartment"><i class="el-icon-delete" style="margin-right:6px;"></i>删除部门</p>
      </div>
      <div>
        <el-button type="primary" size="mini" @click="submitForm" :loading="btnLoading">确 定</el-button>
        <el-button size="mini" @click="$emit('cancel')">取 消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import staffApi from '@/services/api/staffManagement/staffManagement'
import api from '@/services/api/department/department'
export default {
  props: {
    parentDepartmentList: {
      type: Array,
      default: () => []
    },
    dataset: {
      type: Object,
      default: () => { }
    },
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    visible() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  data() {
    let _this = this
    return {
      isParent: false,
      ruleForm: {
        department_category_id: '',
        name: '',
        depart_header: '',
        parent_id: '',
        department_administrators: [],
        status: 1,
      },
      btnLoading: false,
      searchLoading: false,
      isOnce: true,
      leaderList: [],
      departmentType: [],
      departments_id: [],
      treeDataset: [],
      rules: {
        name: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        department_category_id: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        parent_id: [{ required: true, message: '此项不能为空', trigger: 'blur' }]
      },
      props: {
        lazy: true,
        value: 'depart_id',
        label: 'name',
        checkStrictly: true,
        emitPath: true,
        lazyLoad(node, resolve) {
          const { data } = node
          if (_this.treeDataset.length === 0) {
            let treeModel = []
            console.log('开始执行立案 ')
            treeModel = [{
              name: require('@config/projectConfig').companyName,
              depart_id: 888,
              parent_id: 999,
              children: []
            }]
            _this.treeDataset = _this.treeDataset.concat(treeModel)
            resolve(treeModel)
            return
          }
          api.getDepartmentIndex({ pid: data && data.depart_id !== 888 ? data.depart_id : 0, level: 1 }).then(res => {
            let tree = (dataset) => {
              dataset.map(item => {
                if (item.children && item.children.data) {
                  item.children = item.children.data
                } else {
                  return
                }
                if (item.children && item.children.length > 0) {
                  tree(item.children)
                }
              })
            }
            tree(res.data)
            res.data.map(item => {
              item.leaf = !(item.children_amount > 0)
            })
            let treeModel = []
            treeModel = JSON.parse(JSON.stringify(res.data))
            _this.treeDataset = _this.treeDataset.concat(treeModel)
            resolve(treeModel)
          })
        }
      },
    }
  },
  methods: {
    init() {
      this.isOnce = true
      if (this.isEdit) {
        let { depart_id, department_category_id, name, parent_id, status, department_header_user_info, department_administrators, department_tree } = this.dataset
        this.ruleForm = { depart_id, department_category_id, name, parent_id, status, depart_header: department_header_user_info ? department_header_user_info.uid : '', department_administrators: department_administrators.map(res => res.user.uid) }
        // this.dataset.department_header_user_info && this.remoteMethod(this.dataset.department_header_user_info.realname)
        this.leaderList = JSON.parse(JSON.stringify(department_administrators.map(res => res.user)))
        this.departments_id = parent_id == 0 ? [888] : [888, ...department_tree.split(',').filter(res => res).map(res => res * 1)]
        this.treeDataset = []
      } else {
        this.resetForm()
      }
      this.getDepartment()
    },
    async remoteMethod(keyword) {
      if (!keyword) { return }
      this.searchLoading = true
      await staffApi.getStaffIndex({ keyword }).then(res => {
        this.leaderList = JSON.parse(JSON.stringify(res.data))
      })
      this.searchLoading = false
    },
    submitForm() {
      this.btnLoading = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm))
          params.parent_id === 888 ? params.parent_id = 0 : ''
          if (this.isEdit) {
            api.updateDepartment(params).then(res => {
              this.$emit('complete', this.dataset.parent_id)
              this.$message({ message: '部门更新成功', type: 'success' });
              this.btnLoading = false
            }).catch(err => {
              this.btnLoading = false
            })
          } else {
            api.addDepartment(params).then(res => {
              this.$emit('complete', this.dataset.depart_id,true)
              this.$message({ message: '部门新增成功', type: 'success' });
              this.btnLoading = false
            }).catch(err => {
              this.btnLoading = false
            })
          }
        } else {
          this.btnLoading = false
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      this.departments_id = []
      this.treeDataset = []
      this.ruleForm = {
        department_category_id: '',
        name: '',
        depart_header: '',
        parent_id: '',
        department_administrators: [],
        status: 1,
      }
      this.isParent = false
    },
    getDepartment() {
      api.departmentTypeList({}).then(res => {
        this.departmentType = [...res]
        this.changeValue(this.departments_id)
      })
    },
    changeValue(e) {
      let tree = (dataset) => {
        for (let i = 0; i < dataset.length; i++) {
          if (dataset[i].depart_id === e[e.length - 1]) {
            return dataset[i]
          } else if (dataset[i].children) {
            let fl = tree(dataset[i].children)
            if (fl) {
              return fl
            }
          }
        }
      }
      let fl = tree(this.treeDataset)
      if (e && fl && fl.leaf) {
        this.$refs.cascader.toggleDropDownVisible(false)
      }
      this.ruleForm.parent_id = e ? e[e.length - 1] : ''
      e.length === 1 ? this.isParent = true : this.isParent = false
    },
    delDepartment() {
      this.$emit('delDepartment', this.dataset)
    },
  }
}
</script>
<style lang="scss">
.department-dialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .footer-btns {
    text-align: right;
    height: 64px;
    line-height: 64px;
    border-top: 1px solid #e7e8ed;
  }
  .el-input__inner {
    width: 100%;
  }
  .el-form-item__content {
    > div:nth-child(1) {
      width: 100%;
    }
  }
}
</style>
